// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { SearchRequestType } from "../../data/app-core/search-request-type";
import { SearchRequestDocument } from "./documents/search-request-document";
import { ItemEnvelope } from "./base/item-envelope";

export class SearchRequestEnvelope extends ItemEnvelope {
	public constructor(jsonEnvelope: any) {
		super(jsonEnvelope, "SearchRequest");
		if (jsonEnvelope) {
			this.SearchRequestTypes = jsonEnvelope.SearchRequestTypes;
			this.Document = jsonEnvelope.Document;
			this.CreatedOnUTC = jsonEnvelope.CreatedOnUTC;
			this.CreateUserUID = jsonEnvelope.CreateUserUID;
			this.ModifiedOnUTC = jsonEnvelope.ModifiedOnUTC;
			this.ModifyUserUID = jsonEnvelope.ModifyUserUID;
		}
	}
	public SearchRequestTypes: SearchRequestType[] = [];
	public override Document: SearchRequestDocument = new SearchRequestDocument();
	public override get ItemId(): number { return this.Document.Item.SearchRequestId; }
	public override get ItemName(): string { return this.Document.Item.Name; }
}